import { FC } from 'react';
import styled from '@emotion/styled';
import FitualLogo from 'assets/images/fitual-logo.png';

const Logo = styled.img({
  maxWidth: '10rem',
});

export interface AppLogoProps {
  className?: string;
}

export const AppLogo: FC<AppLogoProps> = ({ className }) => {
  return <Logo className={className} src={FitualLogo} alt="fitual-logo" />;
};
